import React, { type HTMLAttributes } from 'react';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import type { NodeVacancy } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodeVacancyTeaserProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<NodeVacancy>;
}

const NodeVacancyTeaser: React.FC<NodeVacancyTeaserProps> = ({ entity }) => {
  const { t } = useTranslation();
  const vacancy = entity.toJS();
  const title = vacancy.title[0].value;
  const language = vacancy.langcode[0].value;
  const path = vacancy.paths[language];
  const media = vacancy.field_media_item[0];

  return (
    <div className="NodeVacancyTeaser">
      <div className="NodeVacancyTeaser__image">
        {media && (
          <DynamicMediaItem
            media={media}
            imageAspectRatio="3_2"
          />
        )}
      </div>
      <div className="NodeVacancyTeaser__text">
        <h2><CoreLink href={path}>{title}</CoreLink></h2>
        <p>{t('content_types.vacancy.type')}</p>
      </div>
    </div>
  );
};

export default NodeVacancyTeaser;
